import Box from '@prezzee/ribbon-ui/lib/components/Box';
import Button from '@prezzee/ribbon-ui/lib/components/Button';
import { SystemProps } from '@chakra-ui/system';
import Typography from '@prezzee/ribbon-ui/lib/components/Typography';
import SparklesIcon from '@prezzee/ribbon-ui/lib/components/icons/SparklesIcon';
import useDisclosure from '@prezzee/ribbon-ui/lib/hooks/useDisclosure';
import SwappableCardModal from './SwappableCardModal';
import useSegment from 'hooks/useSegment';
import { useProduct } from 'contexts/ProductPageContext';

const ZagUpgradePrompt = () => {
  const { setHasUpgradedZag } = useProduct();
  const swappableCardModal = useDisclosure();
  const { customElementInteraction } = useSegment();
  const { purchaseInstanceId } = useProduct();

  const handleSwappableClick = () => {
    setHasUpgradedZag(true);
    customElementInteraction({
      element: 'zag_upgrade_cta',
      purchase_instance_id: purchaseInstanceId,
    });
  };

  return (
    <Box {...containerStyles}>
      <Box {...titleContainerStyles}>
        <Box {...iconContainerStyles}>
          <SparklesIcon color="purple.400" />
        </Box>
        <Typography variant="h4" as="h2" color="gray.800" fontWeight="semibold">
          Give more (for free!)
        </Typography>
      </Box>
      <Typography variant="body" color="gray.600" fontSize="16" lineHeight="24px" fontWeight="normal">
        Convert this gift into a Prezzee Plus eGift Card and let your giftee choose where to spend it; at this brand or
        at another available brand of their choice.
      </Typography>
      <Button variant="primary" onClick={handleSwappableClick} {...baseButtonStyles}>
        Give them more
      </Button>
      <Button variant="link" color="purple.400" {...baseButtonStyles} onClick={swappableCardModal.onOpen}>
        What is a Prezzee Plus eGift Card?
      </Button>
      {swappableCardModal.isOpen && <SwappableCardModal onClose={swappableCardModal.onClose} />}
    </Box>
  );
};

export default ZagUpgradePrompt;

const containerStyles: SystemProps = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  backgroundColor: 'lilac.50',
  marginBottom: '4',
  padding: '4',
  borderRadius: 'md',
};

const titleContainerStyles: SystemProps = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  mb: '3',
};

const iconContainerStyles: SystemProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  mr: '4',
  height: '10',
  width: '10',
  backgroundColor: 'white',
  borderRadius: 'full',
  padding: '2',
};

const baseButtonStyles: SystemProps = {
  my: '3',
};
